import { createFileRoute } from '@tanstack/react-router';
import { ITServicePage } from '@/features/admin/pages';

export const Route = createFileRoute('/admin/service')({
  component: ITServicePage,
});
